import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a ResizeObserver error
    if (
      error &&
      error.message &&
      (error.message.includes('ResizeObserver loop completed with undelivered notifications') ||
       error.message.includes('ResizeObserver loop limit exceeded'))
    ) {
      // Suppress ResizeObserver errors - they are harmless
      return { hasError: false };
    }
    
    // For other errors, show error UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Check if it's a ResizeObserver error
    if (
      error &&
      error.message &&
      (error.message.includes('ResizeObserver loop completed with undelivered notifications') ||
       error.message.includes('ResizeObserver loop limit exceeded'))
    ) {
      // Suppress logging for ResizeObserver errors
      return;
    }
    
    // Log other errors
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-800/60">
          <div className="text-center p-8">
            <h1 className="text-2xl font-bold text-slate-100 mb-4">
              Something went wrong
            </h1>
            <p className="text-slate-400 mb-4">
              We&apos;re sorry for the inconvenience. Please refresh the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
